import { defineComponent as _defineComponent } from 'vue'
import { IVacancy, LocalizationData, LocalizationPath } from '@tokyojob/core'
import { getLocalization } from '@tokyojob/frontend-components'
import { LocalizationService } from '@tokyojob/frontend-core'
import { PropType } from 'vue'
import { getProvidedApp } from '~/base/utils/provided-getter'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-vacancy-detail-description.component',
  props: {
  vacancy: {
    type: Object as PropType<IVacancy>,
    required: true
  }
},
  setup(__props) {

const props = __props;


const localization: LocalizationData = getLocalization(getProvidedApp())
const description = props.vacancy.i18n![0].description!
const jobDescriptionLabel = LocalizationService.t<string>(localization, LocalizationPath.JobDescription)

return { __sfc: true,props, localization, description, jobDescriptionLabel }
}

})